import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Chat = _resolveComponent("Chat")
  const _component_Footer = _resolveComponent("Footer")
  const _component_ModalCarousel = _resolveComponent("ModalCarousel")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Error = _resolveComponent("Error")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      href: "#divChatBody",
      class: _normalizeClass(_ctx.getClass('skip'))
    }, "Skip to main content", 2 /* CLASS */),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(((_ctx.isMobileActive && _ctx.isMobileActive !== null)
      ? _ctx.getClass('chatMobile')+' ' + _ctx.getClass('standaloneMobile') : '') + ' '
      + _ctx.getClass('chat') + ' '  +_ctx.getClass('standalone') + ' '
      + ((_ctx.enableMessageNavigation && _ctx.enableMessageNavigation !== null) ? _ctx.getClass('msg-navigation-enabled') : '') + ' '
      + (_ctx.isEmbeddedNonMobile ? _ctx.getClass('embeddedNonMobile') : ''))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(((_ctx.isMobileActive) ? _ctx.getClass('chatContainerMobile') : '') + ' ' + _ctx.getClass('chatContainer'))
      }, [
        _createCommentVNode(" 955: Show the header with different height and text if an url is opened in iframe for settings.browserTarget as \"iframe\" "),
        _createCommentVNode(" <Header v-if=\"!isIFrameLoaded && !isHideTitleBar\"></Header> "),
        ((!_ctx.isIFrameLoaded && (!_ctx.isHideTitleBar || !_ctx.hideIFrameHeader)) || _ctx.forceShowHeader)
          ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Chat),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('chat-divider'))
        }, null, 2 /* CLASS */),
        _createVNode(_component_Footer),
        _createCommentVNode(" SD-5847: Web Chat Input Container Update "),
        _createElementVNode("div", {
          id: "satisfiTaglineContainer",
          class: _normalizeClass(_ctx.getClass('taglineContainer'))
        }, [
          (!_ctx.hideTagLine)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(((_ctx.isMobileActive && _ctx.isMobileActive !== null) ? _ctx.getClass('taglineMobile') : '') + ' ' + _ctx.getClass('tagline'))
              }, [
                (_ctx.taglineUrl && _ctx.taglineUrl !== 'none')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.taglineUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-hidden": "true",
                      tabindex: "-1"
                    }, _toDisplayString(_ctx.taglineContent), 9 /* TEXT, PROPS */, _hoisted_1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.taglineContent), 1 /* TEXT */))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        (!!_ctx.carouselModalDetail)
          ? (_openBlock(), _createBlock(_component_ModalCarousel, {
              key: 1,
              isBottomSheet: false
            }))
          : _createCommentVNode("v-if", true),
        (!!_ctx.carouselModalList)
          ? (_openBlock(), _createBlock(_component_ModalCarousel, {
              key: 2,
              isBottomSheet: true
            }))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */), [
      [_vShow, _ctx.isConfigurationLoaded]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('safariTempFooter'))
    }, null, 2 /* CLASS */), [
      [_vShow, _ctx.isConfigurationLoaded]
    ]),
    (!_ctx.isConfigurationLoaded && _ctx.errorMessage==null)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.errorMessage!=null)
      ? (_openBlock(), _createBlock(_component_Error, { key: 1 }))
      : _createCommentVNode("v-if", true)
  ]))
}